import React from 'react';
import { openOverlay } from 'data/overlays/overlayHandler';
import { formatPrice } from '../../helpers/priceFormatHelper';
import { useDispatch } from 'react-redux';
import { IBuyBackConfig, IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';
import RenderHTML from 'vkid-ui/lib/Components/RenderHTML';

interface IProps {
    buyBackConfig: IBuyBackConfig;
    setSkipBuyBack: (bool: boolean) => void;
    setAddBuyBackProducts: (bool: boolean) => void;
    skipBuyBack: boolean;
    addBuyBackProducts: boolean;
    buyBackProducts: IBuyBackProduct[];
}

const BuyBackDetail = (props: IProps) => {
    const {
        buyBackConfig,
        setSkipBuyBack,
        setAddBuyBackProducts,
        skipBuyBack,
        addBuyBackProducts,
        buyBackProducts,
    } = props;
    const dispatch = useDispatch();

    return (
        <>
            <fieldset className="tradein-dialog">
                <legend>{buyBackConfig.labels.deviceToTradeinQuestion}</legend>
                <p>
                    <RenderHTML html={buyBackConfig.labels.getMoneyBackLabel} nowrapper />
                </p>
                <div className="tradein-dialog__item">
                    <input
                        type="radio"
                        id="have-tradein01"
                        name="have-tradein"
                        onChange={() => {
                            setSkipBuyBack(true);
                            setAddBuyBackProducts(false);
                        }}
                        checked={skipBuyBack}
                    />
                    <label htmlFor="have-tradein01">{buyBackConfig.labels.deviceToTradein}</label>
                </div>
                <div className="tradein-dialog__item">
                    <input
                        type="radio"
                        id="have-tradein02"
                        name="have-tradein"
                        onChange={() => {
                            setSkipBuyBack(false);
                            setAddBuyBackProducts(true);
                        }}
                        checked={addBuyBackProducts}
                    />
                    <label htmlFor="have-tradein02">{buyBackConfig.labels.noDeviceToTradein}</label>
                    {!buyBackProducts.length && (
                        <div className="tradein-dialog__item-extra">
                            <RenderHTML html={buyBackConfig.labels.buyBackDialogText} nowrapper />
                            <p>
                                <button onClick={() => dispatch(openOverlay({ name: 'buyBack' }))}>
                                    {buyBackConfig.labels.openCalculator}
                                </button>
                            </p>
                        </div>
                    )}
                    {!!buyBackProducts.length && (
                        <>
                            {buyBackProducts.map((buyBackProduct) => {
                                return (
                                    <div className="tradein-dialog__item-extra" key={buyBackProduct.model_id}>
                                        <div className="tradein-product">
                                            <div className="tradein-product__content">
                                                <p>
                                                    <RenderHTML
                                                        html={buyBackConfig.labels.deviceValue
                                                            .replace('%1', buyBackProduct.model_name)
                                                            .replace(
                                                                '%2',
                                                                formatPrice(
                                                                    buyBackProduct.model_price.toString(),
                                                                    true,
                                                                ),
                                                            )}
                                                        nowrapper
                                                    />
                                                </p>
                                                <p className="text-success">
                                                    <RenderHTML html={buyBackConfig.labels.campaignBonus} nowrapper />
                                                </p>
                                            </div>
                                            <button onClick={() => dispatch(openOverlay({ name: 'buyBack' }))}>
                                                {buyBackConfig.labels.change}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            </fieldset>
        </>
    );
};

export default BuyBackDetail;
